import common from './common';
import navbar from './navbar';
import footer from './footer';
import filters from './filters';
import search from './search';
import profile from './profile';
import profileManagement from './profileManagement';
import indexTranslations from './indexPage';
import auth from './auth';
import legal from './legal';
import subscription from './subscription';
import pricing from './pricing';
import how_it_works from './how_it_works';
import messages from './messages';

const translations = {
  common,
  navbar,
  footer,
  filters,
  search,
  profile,
  profileManagement,
  indexPage: indexTranslations,
  auth,
  legal,
  subscription,
  pricing,
  how_it_works,
  messages
};

export default translations;
